import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import CadastroInterceptor from '@finx/web-repository/src/apis/Cadastro/CadastroInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
/* eslint-disable */
const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()
const apiCadastro = new CadastroInterceptor()

export default {
  async getHospitaisByUserCurrent() {
    const request = await api.get('usuario-hospital/current/hospitais')
    return factory.build(request)
  },

  async getAllPessoaAgendamento(param: any) {
    const { pagina, qtdPorPagina } = param
    const query: string = `searchText=${param.searchText}&pagina=${pagina || 0}&qtdPorPagina=${qtdPorPagina || 10}`
    const request = await api.get(`/suporte/pessoas?${query}`)
    return factory.build(request)
  },

  async getPessoaAgendamentoById(id: string) {
    const request = await api.get(`/suporte/pessoa/${id}`)
    return factory.build(request)
  },

  async atualizaPessoaAgendamento(params: any) {
    const request = await api.put(`/suporte/pessoa/alterar`, params)
    return factory.build(request)
  },

  async getProcedimentoPagedSearch(params: any) {
    const { searchText, page, total, tipoProcedimento } = params

    let query = ''

    if (searchText) query += `&searchtext=${searchText}`
    if (page) query += `&page=${page}`
    if (total) query += `&total=${total}`
    if (tipoProcedimento) query += `&tipoProcedimento=${tipoProcedimento}`

    const request = await api.get(`hospitais/${params.hospitalId}/procedimentos/search?${query.substring(1, query.length)}`)
    return factory.build(request)
  },

  async upsertProcedimentoHospital(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/procedimentos`, params)
    return factory.build(request)
  },

  async getAllEquipamentosByHospital(params: any) {
    let query: string = ''

    const { hospitalId } = params
    const { searchText } = params
    const { pagina } = params
    const { qtdPorPagina } = params

    if (searchText) query += `&searchText=${searchText}`

    query += `&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`

    query = `?${query.substring(1, query.length)}`

    const request = await api.get(`/suporte/hospital/${hospitalId}/equipamentos${query}`)
    return factory.build(request)
  },

  async getAllGruposDeEquipamentos(hospitalId: string) {
    // Quantidade máxima de registro pro parâmetro QtdPorPagina...
    const qtdMaxima: number = 32767
    const request = await api.get(`/suporte/hospital/${hospitalId}/gruposequipamentos?pagina=1&qtdPorPagina=${qtdMaxima}`)
    return factory.build(request)
  },

  async getAllGruposEquipamentosByHospital(params: any) {
    let query: string = ''

    const { hospitalId } = params
    const { searchText } = params
    const { pagina } = params
    const { qtdPorPagina } = params

    if (searchText) query += `&searchText=${searchText}`

    query += `&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    query = `?${query.substring(1, query.length)}`

    const request = await api.get(`/suporte/hospital/${hospitalId}/gruposequipamentos${query}`)
    return factory.build(request)
  },

  async upsertEquipamentoByHospital(params: any) {
    const { hospitalId } = params
    const request = await api.put(`/suporte/hospital/${hospitalId}/equipamento`, params)
    return factory.build(request)
  },

  async upsertGrupoEquipamentoByHospital(params: any) {
    const { hospitalId } = params
    const request = await api.put(`/suporte/hospital/${hospitalId}/grupoequipamento`, params)
    return factory.build(request)
  },

  async getAllFornecedores(params: any) {
    const { pagina } = params
    const { qtdPorPagina } = params
    const { searchText } = params
    const { hospitalId } = params
    let query = ''

    if (pagina) query += `&pagina=${pagina || 1}`
    if (qtdPorPagina) query += `&qtdPorPagina=${qtdPorPagina || 25}`
    if (searchText) query += `&searchText=${searchText || ''}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`/suporte/hospital/${hospitalId}/fornecedores${query}`)
    return factory.build(request)
  },

  async upsertFornecedor(params: any) {
    const request = await api.put(`/suporte/hospital/${params.hospitalId}/fornecedores`, params)
    return factory.build(request)
  },

  async getAllConveniosSuporte(hospitalId: String) {
    const request = await api.get(`suporte/hospitais/${hospitalId}/convenios`)
    return factory.build(request)
  },

  async getAllConvenio(hospitalId: String) {
    const request = await api.get(`/hospitais/${hospitalId}/convenios`)
    return factory.build(request)
  },

  async getConvenioById(params: any) {
    const request = await api.get(`/hospitais/${params.hospitalId}/convenio/${params.convenioId}`)
    return factory.build(request)
  },

  async getAllConvenioPlanoByConvenio(hospitalId: String, convenioId: String) {
    const request = await api.get(`suporte/hospitais/${hospitalId}/convenios/${convenioId}/planos`)
    return factory.build(request)
  },

  async upsertConvenioHospital(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/convenio`, params)
    return factory.build(request)
  },

  async upsertConvenioPlanoHospital(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/convenios/${params.convenioId}/plano`, params)
    return factory.build(request)
  },

  async upsertCategoria(params: any) {
    const response = await api.post(`hospitais/${params.hospitalId}/convenio/${params.convenioId}/categoria`, params)
    return factory.build(response)
  },

  async upsertCategoriaPlano(params: any) {
    const response = await api.post(`hospitais/${params.hospitalId}/convenios/categoria-plano`, params)
    return factory.build(response)
  },

  async getAllCaixasCirurgicas() {
    const request = await api.get('caixa-cirurgica')
    return factory.build(request)
  },

  async getAllCaixasCirurgicasByHospitalId(params: any) {
    const request = await api.get(`hospitais/${params.hospitalId}/caixa-cirurgica?searchText=${params.searchText || ''}`)
    return factory.build(request)
  },

  async postCaixaCirurgicaToHospital(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/caixa-cirurgica`, params)
    return factory.build(request)
  },

  async putCaixaCirurgicaToHospital(params: any) {
    const request = await api.put(`hospitais/${params.hospitalId}/caixa-cirurgica`, params)
    return factory.build(request)
  },

  async upsertCaixaCirurgicaBySolicitacaoId(params: any) {
    const request = await api.put(`solicitacoes/${params.solicitacaoId}/caixas-cirurgicas`, params)
    return factory.build(request)
  },

  async deleteCaixaCirurgicaBySolicitacaoId(params: any) {
    const request = await api.delete(`solicitacoes/${params.solicitacaoId}/caixas-cirurgicas/${params.id}`)
    return factory.build(request)
  },

  async getAllAnestesistas(params: any) {
    const { searchText, pagina, qtdPorPagina, hospitalId } = params
    const query: string = `searchText=${searchText || ''}&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 10}&hospitalId=${hospitalId}`
    const request = await api.get(`/anestesistas?${query}`)
    return factory.build(request)
  },

  async getAnestesistaById(id: string) {
    const request = await api.get(`/anestesistas?id=${id}`)
    return factory.build(request)
  },

  async postAnestesista(params: any) {
    const request = await api.post('/anestesistas', params)
    return factory.build(request)
  },

  async putAnestesista(params: any) {
    const request = await api.put('/anestesistas', params)
    return factory.build(request)
  },

  async getAllAnestesistasByHospitalId(params: any) {
    const { hospitalId, searchText, pagina, qtdPorPagina } = params
    const query: string = `searchText=${searchText || ''}&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    const request = await api.get(`suporte/anestesistas/${hospitalId}?${query}`)
    return factory.build(request)
  },

  async getAnestesistaByHospitalId(params: any) {
    const { hospitalId, id } = params
    const request = await api.get(`hospitais/${hospitalId}/anestesistas/${id}`)
    return factory.build(request)
  },

  async postAnestesistaToHospital(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/anestesistas`, params)
    return factory.build(request)
  },

  async putAnestesistaToHospital(params: any) {
    const request = await api.put(`hospitais/${params.hospitalId}/anestesistas`, params)
    return factory.build(request)
  },

  async getAllSalasCirurgicasByHospital(params: any) {
    let query: string = ''

    const { hospitalId } = params
    const { searchText } = params
    const { pagina } = params
    const { qtdPorPagina } = params
    const { retornaSomenteAtivos } = params

    if (searchText) query += `&searchText=${searchText}`
    if (retornaSomenteAtivos) query += `&retornaSomenteAtivos=${retornaSomenteAtivos}`

    query += `&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    query = `?${query.substring(1, query.length)}`

    const response = await api.get(`suporte/hospital/${hospitalId}/salascirurgicas${query}`)
    return factory.build(response)
  },

  async getAllCentrosCirurgicosByHospital(params: any) {
    let query: string = ''

    const { hospitalId } = params
    const { searchText } = params
    const { pagina } = params
    const { qtdPorPagina } = params
    const { retornaSomenteAtivos } = params

    if (searchText) query += `&searchText=${searchText}`
    if (retornaSomenteAtivos) query += `&retornaSomenteAtivos=${retornaSomenteAtivos}`

    query += `&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    query = `?${query.substring(1, query.length)}`

    const response = await api.get(`suporte/hospital/${hospitalId}/centroscirurgicos${query}`)
    return factory.build(response)
  },

  async upsertSalaCirurgica(params: any) {
    const response = await api.put(`suporte/hospital/${params.hospitalId}/salacirurgica`, params)
    return factory.build(response)
  },

  async upsertCentroCirurgico(params: any) {
    const response = await api.put(`suporte/hospital/${params.hospitalId}/centrocirurgico`, params)
    return factory.build(response)
  },

  async getAllTecnicas(hospitalId: string) {
    const response = await api.get(`/hospital/${hospitalId}/tecnicas`)
    return factory.build(response)
  },

  async getAllTecnicasByHospitalId(hospitalId: string) {
    const response = await api.get(`suporte/tecnicas/${hospitalId}`)
    return factory.build(response)
  },

  async getTecnicasDoProcedimentoByProcedimentoId(params: any) {
    const response = await api.get(`procedimentos/${params.procedimentoId}/hospital/${params.hospitalId}/tecnicas`)
    return factory.build(response)
  },

  async upsertProcedimentoTecnica(params: any) {
    const response = await api.post(`suporte/hospital/${params.hospitalId}/procedimentos/${params.procedimentoId}/tecnicas`, params)
    return factory.build(response)
  },

  async atualizarPDFs(params: any) {
    const response = await api.put('suporte/solicitacoes/atualizar-pdf', params)
    return factory.build(response)
  },

  async getMotivosCancelamentoByHospitalId(hospitalId: string) {
    const request = await api.get(`suporte/hospital/${hospitalId}/motivos-cancelamento`)
    return factory.build(request)
  },

  async upsertMotivoCancelamentoByHospital(params: any) {
    const request = await api.put(`suporte/hospital/${params.hospitalId}/motivoscancelamento`, params)
    return factory.build(request)
  },

  async updateConfiguracaoHospital(params: any) {
    const request = await api.put(`suporte/hospital/${params.hospitalId}/configuracao`, params)
    return factory.build(request)
  },

  async getAllProcedimentosApenasHospitalDiaByHospital(params: any) {
    let query: string = ''

    const { hospitalId } = params
    const { searchText } = params
    const { pagina } = params
    const { qtdPorPagina } = params

    if (searchText) query += `&searchText=${searchText}`

    query += `&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    query = `?${query.substring(1, query.length)}`

    const response = await api.get(`suporte/hospital/${hospitalId}/procedimentos-apenas-hospital-dia${query}`)
    return factory.build(response)
  },

  async upsertProcedimentoApenasHospitalDia(params: any) {
    const payload = { ...params }
    delete payload.hospitalId
    const request = await api.put(`suporte/hospital/${params.hospitalId}/procedimento-apenas-hospital-dia`, payload)
    return factory.build(request)
  },

  async getAllStatusSituacaoEtapa() {
    const request = await api.get('suporte/situacao-etapa')
    return factory.build(request)
  },

  async upsertStatusDaSolicitacao(params: any) {
    const request = await api.post(`solicitacao/${params.solicitacaoId}/update-status-etapa`, params)
    return factory.build(request)
  },

  async getAllPaciente(params: any) {
    let query: string = ''

    const { contextoDB, searchText, pagina, qtdPorPagina } = params

    if (searchText) query += `&searchText=${searchText}`

    query += `&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    query += `&contextoDB=${contextoDB}`
    query = `?${query.substring(1, query.length)}`
    const request = await api.get(`suporte/pacientes${query}`)
    return factory.build(request)
  },

  async getPacienteById(id: string) {
    const request = await api.get(`suporte/paciente/${id}`)
    return factory.build(request)
  },

  async updatePaciente(params: any) {
    const request = await api.put('suporte/paciente/alterar', params)
    return factory.build(request)
  },

  async getAllHospitalSuporteConfiguracao() {
    const request = await api.get('suporte/hospitais/configuracao')
    return factory.build(request)
  },

  async getAllTipoAcomodacaoByHospitalId(hospitalId: string) {
    const request = await api.get(`suporte/hospital/${hospitalId}/tipo-acomodacao/all`)
    return factory.build(request)
  },

  async upsertTipoAcomodacao(params: any) {
    const request = await api.put(`suporte/hospital/${params.hospitalId}/tipo-acomodacao`, params)
    return factory.build(request)
  },

  async getOperadoraConvenio(hospitalId: string) {
    const request = await api.get(`hospital/${hospitalId}/operadoras-convenios`)
    return factory.build(request)
  },

  async getConvenioOperadoras(hospitalId: string) {
    const request = await api.get(`hospital/${hospitalId}/convenio-operadoras`)
    return factory.build(request)
  },

  async upsertOperadoraConvenio(params: any) {
    const request = await api.put(`hospital/${params.hospitalId}/convenios-operadoras`, params.data)
    return factory.build(request)
  },

  async backofficeRegulacaoInsertOperadora(params: any) {
    const request = await api.put('operadora/cadastrar', params)
    return factory.build(request)
  },

  async getAllConfigDeFinxParaHisByHospital(params: { hospitalId: string, searchText: string }) {
    const request = await api.get(`suporte/hospital/${params.hospitalId}/definxparahis?searchText=${params.searchText || ''}`)
    return factory.build(request)
  },
  
  async upsertDeFinxParaHis(params: any) {
    const request = await api.put(`suporte/hospital/${params.hospitalId}/de-finx-para-his`, params)
    return factory.build(request)
  },
  
  async deleteDeFinxParaHis(params: any) {
    const request = await api.delete(`suporte/hospital/${params.hospitalId}/de-finx-para-his/${params.deFinxParaHisId}`)
    return factory.build(request)
  },

  async getHospitalConfiguracaoHis(hospitalId: string) {
    const request = await api.get(`suporte/hospital/${hospitalId}/hospitalconfiguracaohis`)
    return factory.build(request)
  },

  async updateHospitalConfiguracaoHis(params: any) {
    const request = await api.put(`suporte/hospital/${params.hospitalId}/configuracao-his`, params)
    return factory.build(request)
  },

  async getPaisAll(hospitalId: string) {
    const request = await api.get(`suporte/hospital/${hospitalId}/paises`)
    return factory.build(request)
  },

  async upsertPaisHospital(data: any) {
    const request = await api.put(`suporte/hospital/${data.hospitalId}/pais`, data)
    return factory.build(request)
  },

  async importPaisJson(hospitalId: string, data: any) {
    const request = await api.upload(`suporte/hospital/${hospitalId}/paises`, data, { 'Content-Type': 'multipart/form-data' })
    return factory.build(request)
  },

  async getArquivoBase64(hospitalId: string, filename: string) {
    const request = await api.get(`hospital/${hospitalId}/arquivo/base64?filename=${filename}`)
    return factory.build(request)
  },

  async getClaimsByRoleName(role: string) {
    const response = await api.get(`suporte/usuarios/roles/${role}/claims`)
    return factory.build(response)
  },

  async getAllSecretarias(params: any) {
    let query: string = ''

    const { searchText } = params
    const { pagina } = params
    const { qtdPorPagina } = params

    if (searchText) query += `&searchText=${searchText}`

    query += `&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    query = `?${query.substring(1, query.length)}`
    const request = await api.get(`suporte/secretarias${query}`)
    return factory.build(request)
  },

  async getSecretariaById(secretariaId: string) {
    const request = await api.get(`suporte/secretaria/${secretariaId}`)
    return factory.build(request)
  },

  async upsertSecretaria(params: any) {
    const request = await api.put('suporte/secretaria', params)
    return factory.build(request)
  },

  async getAllLocaisDeAtendimentoEMedicos(hospitais: string[]) {
    let query: string = ''
    if (hospitais && hospitais.length > 0) {
      hospitais.forEach((c) => {
        query += `&hospitaisIds=${c}`
      })
    }
    query = `?${query.substring(1, query.length)}`
    const request = await api.get(`suporte/locais-atendimento${query}`)
    return factory.build(request)
  },

  async getHospitalSlaConfig(hospitalId: string) {
    const request = await api.get(`suporte/hospital/${hospitalId}/hospitalSlaConfig`)
    return factory.build(request)
  },

  async upsertHospitalSlaConfig(hospitalId: string, hospitalSlaConfigPayload) {
    const request = await api.put(`suporte/hospital/${hospitalId}/hospitalSlaConfig`, hospitalSlaConfigPayload)
    return factory.build(request)
  },
  
  async getHospitalSla(hospitalId: string, hospitalSlaConfigId: string) {
    const request = await api.get(`suporte/hospital/${hospitalId}/hospitalSlaConfig/${hospitalSlaConfigId}/hospitalSla`)
    return factory.build(request)
  },

  async upsertHospitalSla(hospitalId: string, hospitalSlaPayload) {
    const request = await api.put(`suporte/hospital/${hospitalId}/hospitalSla`, hospitalSlaPayload)
    return factory.build(request)
  },

  async deleteHospitalSla(hospitalId: string,hospitalSlaId: string) {
    const request = await api.delete(`suporte/hospital/${hospitalId}/hospitalSla/${hospitalSlaId}`)
    return factory.build(request)
  },
}
